// extracted by mini-css-extract-plugin
export default {"wrapper":"SLIPTAchecklist_wrapper__sGIxi"};